export default function IconRightArrow({ width = 13, height = 13 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="icon/right">
                <path
                    id="Vector (Stroke)"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.64645 3.31075C4.84171 3.11549 5.15829 3.11549 5.35355 3.31075L8.35355 6.31075C8.54882 6.50602 8.54882 6.8226 8.35355 7.01786L5.35355 10.0179C5.15829 10.2131 4.84171 10.2131 4.64645 10.0179C4.45118 9.8226 4.45118 9.50602 4.64645 9.31075L7.29289 6.66431L4.64645 4.01786C4.45118 3.8226 4.45118 3.50602 4.64645 3.31075Z"
                    fill="#999999"
                />
            </g>
        </svg>
    );
}
